export const shortenSlug = slug => `/digital_garden/${slug.substring(29)}`;
